import StorageKeys from "../../const/StorageKeys";
import UtilityHelper from "../utilities/UtilityHelper";

const NODE_ENV = process.env.NODE_ENV;

const SessionStorage = new (class SessionStorage {
  saveValue = (key: string, val: string) => {
    if (NODE_ENV === "production") {
      if (UtilityHelper.isNotEmpty(val)) {
        val = btoa(unescape(encodeURIComponent(val)));
      }
      sessionStorage.setItem(btoa(key), val);
    } else {
      sessionStorage.setItem(key, val);
    }

    //sessionStorage.setItem(btoa(key), val);
    //sessionStorage.setItem(key, JSON.stringify(val));
  };

  getValue = (key: string): any => {
    let val = sessionStorage.getItem(key) ?? "";

    if (NODE_ENV === "production") {
      val = sessionStorage.getItem(btoa(key)) ?? "";

      if (UtilityHelper.isNotEmpty(val)) {
        val = decodeURIComponent(escape(atob(val)));
      }
    }

    return val;
  };

  deleteValue = (key: string) => {
    sessionStorage.removeItem(NODE_ENV === "production" ? btoa(key) : key);
  };

  clearAll = () => {
    this.deleteValue(StorageKeys.branch_id);
    this.deleteValue(StorageKeys.branch_name);
    this.deleteValue(StorageKeys.branch_logo);
    this.deleteValue(StorageKeys.home_branch_product_url);
    this.deleteValue(StorageKeys.home_chat_badge_counter);
    this.deleteValue(StorageKeys.home_notice_badge_counter);

    this.deleteValue(StorageKeys.home_branch_detail);
    this.deleteValue(StorageKeys.home_notices);

    this.deleteValue(StorageKeys.notices_detail);
    this.deleteValue(StorageKeys.preview_image_document);
    this.deleteValue(StorageKeys.recover_password_detail);
    this.deleteValue(StorageKeys.settings_personal_info_email);
    this.deleteValue(StorageKeys.settings_personal_info_phone_number);

    this.deleteValue(StorageKeys.settings_verification_change_email_value);
    this.deleteValue(StorageKeys.settings_verification_change_phone_value);
    this.deleteValue(StorageKeys.settings_verification_detail);
    this.deleteValue(StorageKeys.settings_verification_type);
    this.deleteValue(StorageKeys.signup_third_party_connect_detail);

    this.deleteValue(StorageKeys.signup_verification_detail);
    this.deleteValue(StorageKeys.account_id);

    this.deleteValue(StorageKeys.guest_status);
    this.deleteValue(StorageKeys.verification_type);

    this.deleteValue(StorageKeys.division_id);
    this.deleteValue(StorageKeys.division_title);

    this.deleteValue(StorageKeys.branch_detail_boarding);

    // CHATS
    this.deleteValue(StorageKeys.chats_chat_list);
    this.deleteValue(StorageKeys.chats_chat_selected);
    this.deleteValue(StorageKeys.chats_symetric_key);
    this.deleteValue(StorageKeys.chats_conversation_detail);
    this.deleteValue(StorageKeys.chats_popup_connect);
  };
})();

export default SessionStorage;
